import { render, staticRenderFns } from "./submitAccount.vue?vue&type=template&id=03cd432b&"
import script from "./submitAccount.vue?vue&type=script&lang=js&"
export * from "./submitAccount.vue?vue&type=script&lang=js&"
import style0 from "./submitAccount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports